<template>
  <AppContainer class="conclusion-section">
    <AppCard>
      <TextEditorInput
        id="conclusion"
        v-model.trim="planStore.conclusion"
        recommended-word-count="250 - 350"
        label="Conclusion"
        :word-limit="500"
      />
    </AppCard>
  </AppContainer>
</template>

<script setup>
import { AppContainer } from '@/components/app/index.js';
import { TextEditorInput } from '@/components/form-inputs/index.js';

import { usePlanStore } from '@/store/index.js';
import { AppCard } from '@/components/cards/index.js';

const planStore = usePlanStore();
</script>
